// Pre-populated barge cover form — reads pellet_id from URL search params
// (set by BargeDashboard's pellet "Settings" button via navigate with search params).
// For the blank manual-entry form, see covers.tsx.
import { createFileRoute, useSearch } from '@tanstack/react-router';
import { BargeCoverForm, navigateToError } from '@amber-ui/core';

function BargeCoverRoute() {
  const { barge, pellet } = useSearch({ strict: false }) as {
    barge?: string;
    pellet?: string;
  };
  const barge_id = barge || null;

  if (!barge_id) return null;

  return (
    <BargeCoverForm
      barge_id={barge_id}
      pellet_id={pellet || undefined}
      onError={() => {
        navigateToError();
      }}
    />
  );
}

export const Route = createFileRoute('/_auth/_barge/barge/cover')({
  component: BargeCoverRoute,
});
